import { computed } from "vue";
import { useCatalogReviewStore } from "../stores/catalog-review.store";
export function useCatalogServiceReviews() {
    const store = useCatalogReviewStore();
    return {
        reviews: computed(() => store.items),
        isLoadingReviews: computed(() => store.isLoading),
        reviewsError: computed(() => store.error),
        hasMoreReviews: computed(() => store.hasMore),
        loadReviews: (serviceId) => store.fetchReviews(serviceId),
        loadMoreReviews: () => store.loadMore(),
    };
}
